import * as React from "react";
import { Link } from "react-router-dom";
import { CaseRunClient, ClientResources, FamilialSearchCaseRunModel, QueriesClient } from "@app/api2/api";
import { buildUrl, AppRoutes } from "../../../../AppRoutes";
import { BPColumn } from "@common/BPReactTable";
import { getRunStatusAsString, yesNo } from "@common/Utils";
import { BPDataTable3 } from "@app/components/React/Common/DataTable/BPDataTable3";

interface FamilialSearchCaseRunsProps {
    labId?: number;
    caseId?: number;
    canCreateEvidence: boolean;
    referenceId?: number;
}

export class FamilialSearchCaseRuns extends React.Component<FamilialSearchCaseRunsProps> {
    client: CaseRunClient = new CaseRunClient();
    translationsContext: React.Context<ClientResources>;
    queries = new QueriesClient();


    constructor(props, context) {
        super(props, context);
        
    }

    render() {
        const hasLabId = this.props.labId > -1 && this.props.labId != null;
        const hasCaseId = this.props.caseId != 0 && this.props.caseId != null;

        const columns: BPColumn<FamilialSearchCaseRunModel>[] = [
            {
                Header: "Id",
                accessor: 'id',
                disableSortBy: false,
                Cell: item => <Link to={buildUrl(AppRoutes.CaseRunDetails, {
                    caseId: item.row.original.caseId,
                    caseRunId: item.value,
                    labId: item.row.original.labId
                })}>{item.value}</Link>,
                width: "80px",
            },
            {
                Header: window.translation.common.population,
                accessor: 'populationName',
                disableSortBy: true,
                cellTitle: true,
                width: "200px",
            },
            {
                Header: window.translation.common.contributors,
                accessor: 'referenceList',
                cellTitle: true,
                disableSortBy: true,
                width: this.props.canCreateEvidence ? "200px" : "400px",
            },
            {
                Header: window.translation.parameter.names.kinUseExtendedSearch,
                accessor: 'useExtendedSearch',
                disableSortBy: true,
                width: '130px',
                Cell: item => <>{yesNo(item.value)}</>,
            },
            {
                Header: window.translation.common.hits,
                accessor: 'hitsCount',
                disableSortBy: false,
                width: "70px",
            },
            {
                Header: window.translation.common.status,
                accessor: 'status',
                disableSortBy: true,
                width: "100px",
                Cell: item => <>{getRunStatusAsString(item.value)}</>,
            },
        ];

        return (
            <BPDataTable3
                singleLine
                fixed
                defaultSortField="id"
                defaultSortAsc={false}
                enableSearch={true}
                dataSource={async (p) => {
                    // let pageData = await this.client.getFamilialSearchCaseRuns(this.props.labId, this.props.caseId, p.perPage, p.page, p.sortBy, p.sortDirection, p.searchValue);
                    let pageData = await this.queries.getFamilialSearchRuns(this.props.labId, this.props.caseId, this.props.referenceId, false, p.perPage, p.page, p.sortBy, p.sortDirection, p.searchValue);
                    return pageData;
                }}
                columns={columns}
            />
        );
    }
}

